import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {imageMap} from "../../../../images/imageMap.ts";

export default function SkiftHastighedArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="text-box text-box--gray">
                        <p>
                            Du kan skifte din hastighed ved at kontakte os via chat eller på <a href="mailto:kundeservice@hiper.dk">kundeservice@hiper.dk</a>.
                            Så aftaler vi, hvilken dato, du kan få din nye hastighed.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h3>Din regning kan ændre sig med din nye hastighed</h3>
                        <p>
                            Når du får den nye hastighed, får du måske også en ny pris, som vil fremgå af din regning.
                            Som kunde hos os betaler du en måned forud, så prisen for din nye hastighed fremgår af regningen måneden før, den nye hastighed træder i kraft.
                        </p>
                    </div>
                    <img
                        className="paragraph-image"
                        src={imageMap.help.subscription.speed_change_invoice}
                        alt="Grafik der illustrerer hvor man kan skifte profil."
                    />
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h3>Hvad koster det at skifte hastighed? </h3>
                        <p>
                            Det er gratis at ændre din hastighed.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h3>Får jeg ny router, når jeg skifter min hastighed?</h3>
                        <p>
                            Nej, det gør du ikke. Din nuværende router kan allerede håndtere helt op til 1000 Mbit/s pr. port.
                        </p>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "udstyr",
                        "article": "hvilken-router-foelger-med",
                        "name": "Hvilken router følger med?"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "hastighedstest",
                        "name": "Hastighedstest"
                    }
                ]}
            />
        </>
    )
}
